import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';

import { useCurrentUser } from '@/hooks/useCurrentUser';
import {
  ALL_FACILITIES,
  selectedFacilityIdAtom
} from '@/hooks/useFacilitiesQuery';
import { useIsMobileViewport } from '@/hooks/useIsMobileViewport';
import { useSnackbar } from '@/hooks/useSnackbar';
import useIsScreenerAllFacilitiesSelected from '@/pages/CRM/Screener/Leads/AllLeads/hooks/useIsScreenerAllFacilitiesSelected';

//
export function useMobileViewportFacilitySelection() {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobileViewport = useIsMobileViewport();
  const currentUser = useCurrentUser().data;
  const { showSnackbar } = useSnackbar();
  const [selectedFacilityId, setSelectedFacilityId] = useAtom(
    selectedFacilityIdAtom
  );
  const isAllFacilitiesSelected = useIsScreenerAllFacilitiesSelected();

  useEffect(() => {
    if (
      !currentUser ||
      !isMobileViewport ||
      !(selectedFacilityId === ALL_FACILITIES || isAllFacilitiesSelected) ||
      !currentUser.user_facility_accesses ||
      currentUser.user_facility_accesses.length === 0
    ) {
      return;
    }

    const firstAvailableFacility = currentUser.user_facility_accesses[0];
    if (firstAvailableFacility) {
      navigate(location.pathname, { replace: true });
      setSelectedFacilityId(firstAvailableFacility.facility_id);
      showSnackbar({
        message: `All Facilities unavailable on mobile. ${firstAvailableFacility.facility?.name || 'Your first facility'} is now selected.`,
        severity: 'info'
      });
    }
  }, [
    isMobileViewport,
    selectedFacilityId,
    isAllFacilitiesSelected,
    navigate,
    location.pathname,
    setSelectedFacilityId,
    currentUser,
    showSnackbar
  ]);
}
